// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      dark: {
        primary: '#3f51b5',
        secondary: '#b0bec5',
        accent: '#f75940',
        error: '#b71c1c',
      },
    },
  },
}

export default new Vuetify(opts)